import(/* webpackMode: "eager" */ "/vercel/path0/app/(lobby)/customers/page.tsx");
